import {createStore, applyMiddleware} from 'redux'
import thunkMiddleware from 'redux-thunk'
import {createLogger} from 'redux-logger'
import authReducer from './store/auth/reducer';
import packagesReducer from './store/packages/reducer';
import langReducer from './store/languages/reducer';
import cardsReducer from 'store/cards/reducer';
import difficultyReducer from 'store/difficulties/reducer';
import {reducer as formReducer} from 'redux-form';
import storage from 'redux-persist/lib/storage';
import {persistCombineReducers, persistStore} from 'redux-persist';

import createHistory from 'history/createBrowserHistory';
import {routerMiddleware, routerReducer} from 'react-router-redux';
import crossTabSync from './store/CrossTabSync'


const config = {
    key: 'root',
    storage,
    whitelist: ['auth', 'lang', 'package', 'card', 'difficulty'],
};


// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory();
const reducers = {
    auth: authReducer,
    package: packagesReducer,
    card: cardsReducer,
    lang: langReducer,
    router: routerReducer,
    form: formReducer,
    difficulty: difficultyReducer,
};
const rootReducer = persistCombineReducers(config, reducers);


const middlewares = [thunkMiddleware, routerMiddleware(history)];
if (process.env.REACT_APP_DEBUG === "1") {
    const loggerMiddleware = createLogger();
    middlewares.push(loggerMiddleware)
}
export default function configureStore(preloadedState) {
    const store = createStore(
        rootReducer,
        preloadedState,
        applyMiddleware(...middlewares)
    );
    let persistor = persistStore(store);

    crossTabSync(store, config, {
    whitelist: ['auth'], // Reducers to persist crosstab.
    })
    return { persistor, store }
}


// WEBPACK FOOTER //
// ./src/configureStore.js